import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";

export default function MobileAppDevelopment() {
  return (
    <div className="Mobile-App-Development pt-[160px] sm:pt-0">
      <Helmet>
      <title>Top Mobile App Development Services in Pakistan | Mean3</title>
        <meta
        name="description"
        content="Looking for top mobile app development services in Pakistan? Mean3 offers expert solutions to turn your app ideas into reality."
      />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
    </div>
  );
}
